module.exports = "/_next/static/images/arrow_down-327ad8ba60df0020e8d37ab363d2ec80.svg";